import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavRoomsFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13.5,
			y: 14,
			width: 7,
			height: 7,
			rx: 1,
			fill: "black",
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 14,
			width: 7,
			height: 7,
			rx: 1,
			fill: "black",
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 3,
			width: 7,
			height: 7,
			rx: 1,
			fill: "black",
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.9834,
			y: 2.41421,
			width: 6.25,
			height: 6.25,
			rx: 1,
			transform: "rotate(45 16.9834 2.41421)",
			fill: "black",
			stroke: "black",
			strokeWidth: 1.5
		})
	]
});
export default SvgNavRoomsFilled;
